import { AxiosResponse } from 'axios';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { Statuses, Providers, State, Items } from './types';
import { Dictionary } from '@/types';
import { ACTION_FETCH } from './const';

const { ERROR, READY, WAITING } = Statuses;

const SET_ITEMS = 'setItems';
const SET_STATUS = 'setStatus';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class PageInquiryStore extends VuexModule<State, any> {
    // State
    rulesIssue: string = '';
    rulesConfirm: string = '';
    status: Statuses = READY;

    // Mutations
    @Mutation
    [SET_ITEMS](items: Items) {
      const [data] = items;
      const { rules_issue, rules_confirm } = data;
      this.rulesIssue = rules_issue;
      this.rulesConfirm = rules_confirm;
    }

    @Mutation
    [SET_STATUS](status: Statuses) {
      this.status = status;
    }

    // Actions
    @Action
    async [ACTION_FETCH](params: Dictionary<string>) {
      const { commit } = this.context;
      try {
        commit(SET_STATUS, WAITING);
        const { data } = await $api.get<AxiosResponse<Items>>('pfdod/info', {
          params,
        });
        commit(SET_ITEMS, data.data);
        commit(SET_STATUS, READY);
      } catch (e) {
        commit(SET_STATUS, ERROR);
      }
    }
  }
  return PageInquiryStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/inquiry/store.ts